export default "__VITE_ASSET__m3syi30p__"